angular.module('leanlaw').directive('checkbox', ['$timeout', function ($timeout) {
  return {
    restrict: "E",
    require: "ngModel",
    replace: true,
    template: require("./views/checkbox.html"),
    scope: {
      id: "@",
      ngModel: "=",
      ngDisabled: "=",
      triState: '@'
    },
    link: function ($scope, element, attrs, ctrl) {
      element.removeAttr("id");
      element.bind("click", function (e) {
        e.preventDefault();
        if ($scope.ngDisabled) return;
        $scope.ngModel = !$scope.ngModel;
        ctrl.$setViewValue($scope.ngModel);
      });
    }
  };
}]);